import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export default function Daily_report_view() {
    const [selectedDate, setSelectedDate] = useState(null);
    const [reportList, setReportList] = useState([]);
    // =====================================
    // PAGE LOAD
    // =====================================

    useEffect(() => {
        loadReports();
    }, []);
    // =====================================
    // DATE CHANGE
    // =====================================
    const handleDateChange = (date) => {
        setSelectedDate(date);
        fatchfilteresult(date);
    }
    // =====================================
    // LOAD LAST 2 DAYS REPORT
    // =====================================
    async function loadReports() {
        try {
            let com_id = localStorage.getItem('mem_company_id');
            const response = await fetch(
                'getDailyReports.php',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        company_id: com_id
                    })
                }
            );

            const data = await response.json();

            setReportList(data);

        } catch (error) {

            console.log(error);

        }

    }

    // =====================================
    // FILTER RESULT
    // =====================================

    async function fatchfilteresult(dt) {

        try {

            let com_id =  localStorage.getItem('mem_company_id');
            // FORMAT DATE
            const year = dt.getFullYear();
            const month = String(dt.getMonth() + 1).padStart(2, '0');
            const day =
                String(dt.getDate())
                .padStart(2, '0');
            const formattedDate =
                `${year}-${month}-${day}`;
            const response = await fetch(
                'getDailyReports.php',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        company_id: com_id,
                        selected_date: formattedDate
                    })
                }
            );
            const data = await response.json();
            setReportList(data);
        } catch (error) {
            console.log(error);
        }
    }

    // =====================================
    // FORMAT DISPLAY DATE
    // =====================================

    function formatDate(dateString) {

        const options = {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        };

        return new Date(dateString)
            .toLocaleDateString(
                'en-GB',
                options
            );

    }

    return (

        <div>

            <div className='fullwidth pb-30 pull_left'>

                <h3>Daily Report Section</h3>

                <p>
                    Here you can see all reports
                    sent by developer daily basis.
                </p>

                <div className="date_searchbar">

                    <p>Filter By Date</p>

                    <span>

                        <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            maxDate={new Date()}
                            dateFormat="yyyy-MM-dd"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={50}
                            scrollableYearDropdown
                            isClearable
                            placeholderText='Select Date'
                        />

                    </span>

                </div>

            </div>

            <div className='vl_listing_row'>

                {
                    reportList.length > 0 ? (

                        reportList.map((item, index) => (

                            <div className='vl_dsh_one_full reportcell'
                                key={index}
                            >
                                <h3>
                                    {item.proname}
                                </h3>
                                <p className='infotext'>
                                    Posted By :
                                    {' '}
                                    {item.username}
                                </p>
                                <p className='highlighttext pb-15'>
                                    Posted on:
                                    {' '}
                                    {formatDate(item.created_date)}
                                </p>
                                <p>
                                    {item.report_text}
                                </p>
                            </div>
                        ))
                    ) : (
                        <div className='vl_dsh_one_full reportcell'>
                            <p>
                                No report found
                            </p>
                        </div>
                    )
                }
            </div>
        </div>
    )
}